const getDefaultCompleteResult = (players: string[]) => {
  const result = {
    [players[0]]: {
      sessionResult: 0,
      wonOffense: 0,
      lostOffense: 0,
      lostDefense: 0,
      offensePoints: 0,
      defensePoints: 0,
      completeResult: 0,
    },
    [players[1]]: {
      sessionResult: 0,
      wonOffense: 0,
      lostOffense: 0,
      lostDefense: 0,
      offensePoints: 0,
      defensePoints: 0,
      completeResult: 0,
    },
    [players[2]]: {
      sessionResult: 0,
      wonOffense: 0,
      lostOffense: 0,
      lostDefense: 0,
      offensePoints: 0,
      defensePoints: 0,
      completeResult: 0,
    },
  }
  if (players.length === 4) {
    result[players[3]] = {
      sessionResult: 0,
      wonOffense: 0,
      lostOffense: 0,
      lostDefense: 0,
      offensePoints: 0,
      defensePoints: 0,
      completeResult: 0,
    }
  }
  return result
}

export default getDefaultCompleteResult
